import { ORDER_LOADING } from 'redux/modules/trolley/actions/types';
import { CUSTOMER_SLOT_REQUEST } from 'redux/modules/customer-slot/actions/types';
import { LOADING as PRODUCTS_LOADING } from 'redux/modules/search-and-browse/actions/types';
import { CLIENT_PAGE_LOADED } from 'redux/modules/page/actions/types';
import { LOAD_PREFERENCES_FULFILLED } from 'redux/modules/marketing-preferences/actions/types';
import { MARKETING_PREFERENCES_ACKNOWLEDGED } from 'redux/modules/my-account/actions/types';
import { GET_MEAL_DEAL } from 'redux/modules/meal-deals/actions/types';
import { GET_FAVOURITES } from 'redux/modules/favourites-experience/actions/types';
import { GET_MORE_OF_WHAT_YOU_LOVE_SUGGESTIONS } from 'redux/modules/more-of-what-you-love/actions/types';
import { GET_QUICK_SHOP_SUGGESTIONS } from 'redux/modules/quick-shop/actions/types';
import { GET_BOUGHT_IN_STORE_PRODUCTS } from 'redux/modules/bought-in-store/actions/types';
import { GET_SHOP_BY_LIST_SUGGESTIONS } from 'redux/modules/shop-by-list/actions/types';

export const MONETATE_ACTIONS = [
  CLIENT_PAGE_LOADED,
  ORDER_LOADING,
  PRODUCTS_LOADING,
  GET_MEAL_DEAL.request,
  GET_FAVOURITES.request,
  GET_BOUGHT_IN_STORE_PRODUCTS.request,
  GET_MORE_OF_WHAT_YOU_LOVE_SUGGESTIONS.request,
  GET_QUICK_SHOP_SUGGESTIONS.request,
  GET_SHOP_BY_LIST_SUGGESTIONS.success,
  CUSTOMER_SLOT_REQUEST,
  LOAD_PREFERENCES_FULFILLED,
  MARKETING_PREFERENCES_ACKNOWLEDGED,
];
